import SalesProformaPage from "../../solarent-operator/sales-proforma";

const ManagementSalesProformaPage = () => <SalesProformaPage source="Management" />;

export default ManagementSalesProformaPage;
